import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Card, Spinner, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import axios from "axios";

export default function Verify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const hasVerified = useRef(false); // 👈 guard

  useEffect(() => {
    if (hasVerified.current) return;
    hasVerified.current = true;

    const verify = async () => {
      try {
        await axios.get(`/api/auth/verify/${token}`);
        setStatus("success");
      } catch {
        setStatus("error");
      }
    };

    verify();
  }, [token]);

  return (
    <Container 
          style={{ height: "80vh" }}
    className="d-flex justify-content-center align-items-center">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
        <Card className="p-4 shadow-lg border-0 text-center" style={{ width: 420 }}>
          {status === "loading" && (
            <>
              <Spinner animation="border" className="mb-3" />
              <p>Verifying your email…</p>
            </>
          )}

          {status === "success" && (
            <>
              <h3 className="text-gradient mb-3">Email Verified ✅</h3>
              <p>You can now log in.</p>
              <Button onClick={() => navigate("/login")} className="fw-bold">
                Go to Login
              </Button>
            </>
          )}

          {status === "error" && (
            <>
              <h3 className="text-danger mb-3">Verification Failed ❌</h3>
              <p>The link is invalid or expired.</p>
            </>
          )}
        </Card>
      </motion.div>
    </Container>
  );
}
